import { ArrowForwardIos, Message } from "@mui/icons-material";
import { Box, Button, Container, List, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router";
import {
  PageContainer,
  PageContent,
  PageHeader,
} from "../../../components/layout/page";

interface MenuButtonProps {
  children: React.ReactNode;
  page: string;
  startIcon?: React.ReactNode;
}

const MenuButton: React.FC<
  MenuButtonProps & React.ComponentProps<typeof Button>
> = ({ children, page, startIcon, ...props }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const buttonStyles = (theme: any) => ({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: 500,
    width: "100%",
    px: 2.5,
    py: 2,
    my: 1.5,
    borderRadius: "12px",
    border: "none",
    transition: "all 0.2s ease-in-out",
    color: theme.palette.grey[900],
    "&:hover": {
      background: theme.palette.grey[100],
      color: theme.palette.primary.main,
    },
  });
  const [isActive, setIsActive] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsActive(location.pathname.includes(page));
  }, [location, page]);

  return (
    <Link to={page} style={{ textDecoration: "none", color: "inherit" }}>
      <Button
        fullWidth
        startIcon={startIcon}
        endIcon={<ArrowForwardIos sx={{ fontSize: 16, opacity: 0.5 }} />}
        color="inherit"
        sx={
          isActive
            ? (theme) => ({
                ...buttonStyles(theme),
                background: theme.palette.action.selected,
                color: theme.palette.primary.main,
                boxShadow: `0px 0px 4px ${theme.palette.grey[400]}`,
                transform: `scale(1.01)`,
              })
            : buttonStyles
        }
        {...props}
      >
        <Typography
          sx={{
            width: "100%",
            alignSelf: "flex-start",
            textAlign: "left",
            alignItems: "center",
            fontWeight: 500,
            letterSpacing: 0.1,
          }}
        >
          {children}
        </Typography>
      </Button>
    </Link>
  );
};

const servicePages: Array<{
  page: string;
  displayName: string;
  icon: React.ReactElement;
}> = [
  {
    page: "messages",
    displayName: "Maintenance Messages",
    icon: <Message />,
  },
];

const RunwayServiceWrapper: React.FC = () => {
  return (
    <PageContainer variant="full">
      <PageHeader title="Runway Services" />
      <PageContent>
        <Container maxWidth="xl" sx={{ px: 2 }}>
          <Box display="flex">
            <List
              sx={{
                minWidth: 300,
                backgroundColor: "#fff",
                p: 0,
                m: 0,
              }}
            >
              {servicePages.map((page) => (
                <MenuButton
                  key={page.page}
                  page={page.page}
                  startIcon={page.icon}
                >
                  <Box display="flex" alignItems="center">
                    <Typography>{page.displayName}</Typography>
                  </Box>
                </MenuButton>
              ))}
            </List>
            <Box flexGrow={1} sx={{ px: 5, overflow: "scroll" }}>
              <Outlet />
            </Box>
          </Box>
        </Container>
      </PageContent>
    </PageContainer>
  );
};

export default RunwayServiceWrapper;
